import {
	getAllUsersStart,
	getAllUsersSucSuccess,
	getAllUsersFailure,
	getAllStudentsStart,
	getAllStudentsSucSuccess,
	getAllStudentsFailure,
	getAllUserByIdStart,
	getAllUserByIdSucSuccess,
	getAllUserByIdFailure,
} from '../reducers/users';

import axios from "../../api/axios";

export const getAllUsers = (page, pageSize, query) => async (dispatch) => {
	dispatch(getAllUsersStart());
	try {
		const response = await axios.get(`/users/getAllUsers?page=${page}&pageSize=${pageSize}&search=${query}`,
			{
				withCredentials: true,
			});
		if (response.status === 200) {
			dispatch(getAllUsersSucSuccess(response.data));
			return {
				status: response.status,
				totalRows: response.data.total,
				page: response.data.page,
				pageSize: response.data.pageSize
			};
		}
		return response.status;
	} catch (error) {
		dispatch(getAllUsersFailure());
	}
};

export const getAllStudents = ({
	fromDate,
	toDate,
	statusStudent,
	statusSubscription,
	identifier,
	query,
	usePagination,
	sort,
	page,
	pageSize,
	sendExcel = false
}) => async (dispatch) => {
	if (!sendExcel) {
		dispatch(getAllStudentsStart());
	}
	try {
		const response = await axios.get(`/users/getAllStudents?page=${page}&pageSize=${pageSize}&search=${query}&usePagination=${usePagination}&statusStudent=${statusStudent}&statusSubscription=${statusSubscription}&fromDate=${fromDate}&toDate=${toDate}&sort=${sort.value}&identifier=${identifier}&sendExcel=${sendExcel}`,
			{
				withCredentials: true,
			});
		if (response.status === 200) {
			if (!sendExcel) {
				dispatch(getAllStudentsSucSuccess(response.data));
			}
			return {
				status: response.status,
				totalRows: response.data.total,
				page: response.data.page,
				pageSize: response.data.pageSize,
				excelData: response.data.excelData,
			};
		}
	} catch (error) {
		if (!sendExcel) {
			dispatch(getAllStudentsFailure());
		}
	}
};

export const getUserById = (idUser) => async (dispatch) => {
	dispatch(getAllUserByIdStart());
	try {

		const response = await axios.get(`/users/getUserById/${idUser}`);
		dispatch(getAllUserByIdSucSuccess(response.data))

	} catch (error) {
		dispatch(getAllUserByIdFailure());
	}
};

export const createNewUserByInvitation = ({ email, typeUser }) => async (dispatch) => {
	try {
		const response = await axios.post(`/users/newUserByInvitation`,
			{
				email,
				typeUser
			},
			{
				withCredentials: true,
			});
		if (response.status === 201) {

			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};

export const createNewUser = (payload) => async (dispatch) => {

	const { firstName, secondName, lastName, secondSurname, email, location, typeUser, phone, dateBirth, password
	} = payload;

	try {
		const response = await axios.post(`/users/`,
			{
				firstName,
				secondName,
				lastName,
				secondSurname,
				email,
				location,
				typeUser,
				phone,
				dateBirth,
				password
			});
		if (response.status === 201) {

			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};

export const updateProfileUser = (data, userId) => async (dispatch) => {
	try {
		const response = await axios.put(`users/update-profile/${userId}`,
			{
				data
			});
		if (response.status === 201) {
			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};

export const updateProfileUser2 = (data, userId) => async (dispatch) => {
	try {
		const response = await axios.put(`users/update-profile/${userId}`,
			{
				data
			});
		if (response.status === 201) {
			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};
